import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  QueryList,
  ViewChildren,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener,
  OnDestroy
} from '@angular/core';
import { ScratchCard } from './scratch-card.class';
import { ScratchCardConfig } from './scratch-card.models';
import { NgZone } from '@angular/core';
import { HttpClientService } from '../../../core/services/http-client.service'; // Import the HttpClientService
import { ToastService } from '../../../core/services/toast.service';
import {CommonService} from "../../../core/services/common.service"; // Import the ToastService

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.css']
})
export class OffersComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('card') cards: QueryList<ElementRef<HTMLDivElement>>;

  public displayCanvas: boolean = true;

  offers: Array<any> = [];

  private scratchCards: ScratchCard[] = [];
  private customerId: any;
  private androidId: any;
  private loader: boolean;

  constructor(
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private httpService: HttpClientService,
    private toast: ToastService ,
  private common: CommonService
  ) { this.customerId = this.common.getStorage("customer").id;
    this.androidId = this.common.getStorage(this.common.androidlogId);
  }

  ngOnInit() {
    this.customerId = this.common.getStorage("customer").id;
    this.androidId = this.common.getStorage(this.common.androidlogId);
    let obj = {
      id: this.customerId,
    };
    this.loader = true;
    this.httpService.get("store/ScratchOffers", obj).subscribe(
      (data) => {
        this.loader = false;

        for (let offer of data.response) {
          if (offer.offerName != null) {
            this.offers.push(offer);
          }
        }
      },
      (error) => {
        if (error.statusCode == 400) {
          this.loader = false;
          this.toast.error(error.response.message);
          console.log("error", error);
        } else {
          this.loader = false;
          console.log("error", error);
          this.toast.error("Something went wrong");
        }
      }
    );
  }

  ngAfterViewInit(): void {
    this.initializeScratchCards();
    this.cards.changes.subscribe(() => this.initializeScratchCards());
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.initializeScratchCards();
  }

  private initializeScratchCards(): void {
    this.scratchCards.forEach(sc => sc.destroy());
    this.scratchCards = [];

    this.cards.forEach((card, index) => {
      if (!this.offers[index].expired && !this.offers[index].scratched) {
        const scratchCard = this.initializeScratchCard(card.nativeElement, this.offers[index]);
        this.scratchCards.push(scratchCard);
      }
    });
  }

  private initializeScratchCard(element: HTMLDivElement, offer: any): ScratchCard {
    const scConfig: ScratchCardConfig = {
      width: element.offsetWidth, // Dynamically set width to match parent
      height: element.offsetHeight, // Dynamically set height to match parent
      zoneRadius: 100,
      percentToFinish: 60,
      canvasClass: 'canvas',
      element: element,
      mask: '#FFCD00',
      maskType: 'color',
      callback: () => {
        offer.scratched = true;
        this.cdr.detectChanges();
        this.scratched(offer.id); // Call the API when the card is fully scratched
      },
    };

    const scratchCard = new ScratchCard(scConfig);
    this.ngZone.runOutsideAngular(() => scratchCard.init());
    return scratchCard;
  }

  // Method to handle the API call when the scratch card is fully scratched
  private scratched(id: number): void {
    this.httpService.post("/store/ScratchedOffer?id=" + id).subscribe(
      (data) => {
        if (data.responseStatus === "SUCCESS") {
          this.toast.success("Offer scratched successfully!");
        } else {
          this.toast.error("Problem creating. Please try after some time.");
        }
      },
      (err) => {
        if (err.statusCode === 400) {
          this.toast.error(err.json().response.message);
          console.log("error", err.json());
        } else {
          console.log("error", err);
          this.toast.error("Something went wrong");
        }
      }
    );
  }
}
